import React, { useEffect, useMemo } from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import type { ExperienceAttributes } from '@atlassian/jira-experience-tracker/src/common/types.tsx';

import { CONDITIONAL_FORMATTING_EXPERIENCE } from '../../common/constants.tsx';

const STABLE_EMPTY_OBJECT = {};

function ExperienceFailureBase({
	experience,
	error,
	attributes = STABLE_EMPTY_OBJECT,
}: {
	experience: string;
	error: Error;
	attributes?: ExperienceAttributes;
}) {
	const onExperienceFailure = useExperienceFail({
		experience,
		attributes,
	});

	useEffect(() => {
		onExperienceFailure(experience, error);
	}, [attributes, error, experience, onExperienceFailure]);

	useMemo(() => {
		if (__SERVER__) {
			onExperienceFailure(experience, error);
		}
	}, [error, experience, onExperienceFailure]);

	return null;
}

export function ExperienceFailure(props: { error: Error; attributes?: ExperienceAttributes }) {
	return <ExperienceFailureBase {...props} experience={CONDITIONAL_FORMATTING_EXPERIENCE} />;
}
